import { defineComponent as r, useSlots as n, openBlock as u, createBlock as f, unref as o, createSlots as d, withCtx as a, renderSlot as l } from "vue";
import c from "./ghl-ui.es239.js";
const i = r({
  name: "UIBadge",
  inheritAttrs: !1
}), y = r({
  ...i,
  props: {
    id: {
      type: String,
      required: !0
    },
    color: {
      type: String
    },
    dot: {
      type: Boolean
    },
    max: {
      type: Number
    },
    processing: {
      type: Boolean
    },
    showZero: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: !0
    },
    type: {
      type: String,
      default: "default"
    },
    value: {
      type: [Number, String],
      default: void 0
    },
    offset: {
      type: Array
    }
  },
  setup(e) {
    const s = n();
    return (t, m) => (u(), f(o(c), {
      color: e.color,
      dot: e.dot,
      max: e.max,
      processing: e.processing,
      "show-zero": e.showZero,
      show: e.show,
      type: e.type,
      value: e.value,
      offset: e.offset
    }, d({
      default: a(() => [
        l(t.$slots, "content")
      ]),
      _: 2
    }, [
      o(s).value ? {
        name: "value",
        fn: a(() => [
          l(t.$slots, "value")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["color", "dot", "max", "processing", "show-zero", "show", "type", "value", "offset"]));
  }
}), p = y;
export {
  p as default
};
